import { Chip } from "@mui/material"
import { Status } from "graphql/types"
import { getColorForStatus, getTextForStatus } from "utils/status"

type StatusChipProps = {
  status: Status
}

export const StatusChip = (props: StatusChipProps) => {
  const { status } = props
  return (
    <Chip label={getTextForStatus(status)} color={getColorForStatus(status)} />
  )
}
